export class User
{
    static isMoral(person_type) {
        return person_type === 0 || person_type === 3 || person_type === 4;
    }
}
